// extracted by mini-css-extract-plugin
export default {"testimonials":"testimonials_testimonials__Rg96T","testimonialContainer":"testimonials_testimonialContainer__kRJhT","testimonial":"testimonials_testimonial__rB9T9"};